import {post} from '../utils';

const dao = {
  updatePartner: partner =>
    post('/smb-backend/partner/customer/update-customer.action', {
      customer: {...partner},
    }),
};

export default dao;
